var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_vm.visible ? _c('ps-language-select', { attrs: { "data": _vm.languageOptions, "disabled": _vm.preparingPreview, "placeholder": this.$t('playTurbo.custom.previewer.selectText') }, on: { "change": _vm.changeLanguage }, model: { value: _vm.fallbackLocale, callback: function callback($$v) {
        _vm.fallbackLocale = $$v;
      }, expression: "fallbackLocale" } }) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };